
import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const TopicBasicInfoComponent = ({
  parentTopicsList, handleInnerFormChange, selectedTopics
}: any) => {

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Title"
              labelField="Title"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Title'
                );
              }}
              type="text"
              value={selectedTopics?.Title}
            />
            <InputContainer
              label="Parent Topic"
              labelField="Title"
              list={parentTopicsList}
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'ParentId'
                );
              }}
              optionName="Choose Parent Topic"
              type="select"
              valueField="Id"
              value={selectedTopics?.ParentId}
            />
            <div className='col-span-full'>
              <InputContainer
                label="Description"
                name="Description"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event,
                    'Description'
                  )
                }}
                type="rte"
                value={selectedTopics?.Description}
              /></div>
          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Info"
      />
    </>
  )
}

export default TopicBasicInfoComponent;